import { Shield, Handshake, Target, Star, HelpCircle } from "lucide-react";

const ICON_MAP = {
  star: Star,
  handshake: Handshake,
  shield: Shield,
  target: Target,
};

const PALETTE = {
  platform_advocate: { color: "#39ff14", glow: "rgba(57, 255, 20,0.35)" },
  community_volunteer: { color: "#00aaff", glow: "rgba(0, 170, 255,0.35)" },
  cybersecurity_supporter: { color: "#00aaff", glow: "rgba(0, 170, 255,0.35)" },
  threat_reporter: { color: "#39ff14", glow: "rgba(57, 255, 20,0.35)" },
};

export function BadgePill({ badge, owned = false }) {
  const Icon = ICON_MAP[badge.icon] || HelpCircle;
  const pal = PALETTE[badge.badge_id || badge.id] || { color: "#00aaff", glow: "rgba(0, 170, 255,0.3)" };
  const inactive = !owned;
  const tooltip = !owned
    ? (badge.coming_soon_label ? `Coming soon — ${badge.coming_soon_label}` : "Not yet earned")
    : badge.description || "";
  return (
    <div
      title={tooltip}
      className={`group relative flex items-center gap-2 px-3 py-2 rounded-md border ${inactive ? "border-[rgba(0,170,255,0.18)] opacity-50" : ""}`}
      style={!inactive ? { borderColor: pal.color, boxShadow: `0 0 14px ${pal.glow}` } : {}}
      data-testid={`badge-${badge.badge_id || badge.id}`}
    >
      <Icon size={16} style={{ color: inactive ? "#94a3b8" : pal.color }} />
      <div>
        <div className="text-xs font-medium text-white">{badge.name}</div>
        <div className="font-mono-tech text-[9px] uppercase tracking-[0.22em] text-[#94a3b8]">
          {inactive ? (badge.coming_soon_label || "Locked") : "Earned"}
        </div>
      </div>
    </div>
  );
}

export default function BadgeList({ owned = [], catalog = [], "data-testid": testId }) {
  const ownedIds = new Set(owned.map((b) => b.badge_id));
  // Render each catalog entry exactly once (owned or not).
  const items = catalog.map((c) => {
    const myBadge = owned.find((o) => o.badge_id === c.id);
    return myBadge ? { ...c, ...myBadge, name: c.name } : { ...c, badge_id: c.id };
  });
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {items.map((b) => (
        <BadgePill key={b.badge_id || b.id} badge={b} owned={ownedIds.has(b.badge_id || b.id)} />
      ))}
    </div>
  );
}
